import { gql } from '@apollo/client';

import SellerInputFragment from '../fragments/sellerInputFragment';

const getSellerInputQuery = gql`
  query GetSellerInputQuery($sellerInputUUID: String!, $featureFlagNames: [String!]!) {
    reception {
      getSellerInput(input: { uuid: $sellerInputUUID }) {
        sellerInput {
          ...SellerInputFragment

          featureFlagsAmplitude(experimentNames: $featureFlagNames) {
            name
            enabled
          }
        }
      }
    }
  }
  ${SellerInputFragment}
`;

export default getSellerInputQuery;
